<template>
  <div class="zuimingcont between">
    <div class="zuiming">
      <div class="hot_charges">
        <div class="prititle">热门罪名</div>
        <chargeslist :intlist="hotzmlist" />
      </div>
      <div class="com_used_charges">
        <div class="prititle">常用罪名</div>
        <chargeslist :intlist="cyzmlist" />
      </div>
      <div class="ct3">
        <div class="top flex_start" @click="tojump({path:'/laws/lawsarticl'})">
          <div>
            <img src="../../../assets/jpcol/artic1_sample.png" alt="" />
          </div>
          <div class="inf">
            <div class="ti ellipsis">
              最高人民法院关于常见犯罪的量刑指导意见
            </div>
            <div class="dec">
              {{
                `刑事案件的定罪量刑是相当重要，量刑是否公正公平都是机器重要的，随着时间推移，各类犯罪的量刑也在不断发生变化。那么刑事案件的量刑标准是`
                  | toEllipsisFilter(90)
              }}
            </div>
          </div>
        </div>
        <ul class="atclist">
          <li v-for="item in 8" :key="item" class="ellipsis"  @click="tojump({path:'/laws/lawsarticl'})">
            伪造、变造、买卖国家机关公文、证件、印章罪需要哪些犯罪构成
          </li>
        </ul>
      </div>
      <div class="hotcitylaw">
        <div class="prititle">热门城市刑法专业律师</div>
        <div class="citylawlist flex_start wrap">
          <div class="citylawitem" v-for="item in 16" :key="item">
            北京刑事辩护律师
          </div>
        </div>
      </div>
    </div>
    <div class="zixun">
      <!-- <div class="crdelac">
        <sub-title text="刑事辩护最新咨询" class="mb20" />
        <home-timeline :fonum="4" :spl="10" :isacolor="true" />
      </div> -->
      <div class="crhotpro mt30">
        <sub-title text="刑事罪名库" class="mb20" />
        <ul>
          <li class="ellipsis" v-for="item in 8" :key="item">
            监视居住派出所执行
          </li>
        </ul>
      </div>

		<div class="crhotpro mt30">
		  <sub-title text="刑事辩护相关知识" class="mb20" />
		  <ul>
		    <li class="ellipsis" v-for="item in 8" :key="item">
		      监视居住派出所执行
		    </li>
		  </ul>
		</div>
		
		<div class="laonsel">
		<sub-title text="快速查找刑事辩护律师" class="mb20" />
		  <div class="between">
		    <el-select
		      :popper-append-to-body="false"
		      v-model="value"
		      placeholder="请选择"
		      class="sele1"
		    >
		      <el-option
		        v-for="item in provincecity"
		        :key="item.id"
		        :label="item.name"
		        :value="index"
		      >
		      </el-option>
		    </el-select>
			<span class="FontGray1 flex line"></span>
		    <el-select
		      v-model="value1"
		      :popper-append-to-body="false"
		      placeholder="请选择"
		      class="sele1"
		    >
		      <el-option
		       v-for="item in provincecity[theindex].children"
		       :key="item.id"
		       :label="item.name"
		       :value="item.name"
		      >
		      </el-option>
		    </el-select>
		  </div>
		  
		  <div class="kscz">快速查找</div>
		</div>
		
		<div class="inlineclass flex-col ">
			<span class="FontBlack FontSize18 FontBold tit">在线咨询刑事辩护专业律师</span>
			<span class="FontSize12 FontGray1">请输入案情经过和维权诉求，尽量详实以得到更精准的解答</span>
			<div class="btn FontWhite FontSize18">
				快速咨询
			</div>
		</div>
		
		
		
      <div class="hotcharf mt30">
        <sub-title text="热门罪名关注排行榜" class="mb20" />
        <ul>
          <li class="flex item" v-for="(item, index) in 10" :key="index">
            <div class="im1">
              <img src="~assets/home/sort_1.png" v-if="index == 0" />
              <img src="~assets/home/sort_2.png" v-else-if="index == 1" />
              <img src="~assets/home/sort_3.png" v-else-if="index == 2" />
              <div v-else>{{ index + 1 }}</div>
            </div>
            <div class="im2 ellipsis">非法收购、非法收购</div>
            <div class="im3">223人关注</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import chargeslist from "../components/chargeslist";
import subTitle from "views/home/components/subTitle";
import homeTimeline from "views/home/components/homeTimeline/homeTimeline";
export default {
  components: {
    chargeslist,
    subTitle,
    homeTimeline,
  },
  data:() => ({
    hotzmlist:[],
    cyzmlist:[],
	provincecity:[],
	majors:[],
	theindex:0,
	value: "北京",
	value1: "北京",
	value2: "",
  }),
  beforeMount() {
    this.getzuimin('hot','hotzmlist')
    this.getzuimin('new','cyzmlist')
  },
  created() {
  	  // alert(this.$route.params.test)
  	this.$http.home.provincecity().then(res =>{
  		this.provincecity = res.data
  		this.value = this.provincecity[0].name
  		this.value1 = this.provincecity[0].children[0].name
  	})
  	this.$http.home.majors().then(res =>{
  		this.majors = res.data
  		this.value2 = this.majors[0].name
  	})
  },
  methods:{
    getzuimin(type,key){
      let data = {
        page:1,
        limit: 5,
        order: type,
      }
      this.$http.jpcol.getzuiminlist(data)
        .then(res => {
          this[key] = res.data.data
        })
    },
    tojump(item){
      console.log("点击了跳转",item);
      this.$router.push({
        path:item.path
      })
    },
	changeprov(e){
	  this.theindex = e
	  console.log(e)
	},
  }
};
</script>

<style lang="scss" scoped>
.zuimingcont {
  width: 1200px;
  padding: 20px 0 50px;
  margin: 0 auto;
  align-items: flex-start;
  .zuiming {
    width: 855px;
    .prititle {
      font-size: 24px;
      color: #222222;
    }
    .hot_charges,
    .com_used_charges {
      width: 100%;
      background: #ffffff;
      padding: 20px 22px;
      margin-bottom: 30px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
    }
    .ct3 {
      width: 100%;
      height: 674px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      padding: 32px 20px;
      .top {
        align-items: flex-start;
        cursor: pointer;
        img {
          width: 280px;
          height: 200px;
          margin-right: 28px;
        }
        .inf {
          width: 506px;
          .ti {
            margin-top: 18px;
            font-size: 22px;
            color: #333333;
          }
          .dec {
            margin-top: 16px;
            font-size: 16px;
            color: #999999;
            line-height: 36px;
          }
        }
      }
      .atclist {
        padding-left: 20px;
        margin-top: 28px;
        li {
          font-size: 18px;
          line-height: 48px;
          color: #333333;
          position: relative;
          cursor: pointer;
          &:hover {
            color: #0465ea;
          }
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -20px;
            width: 8px;
            height: 8px;
            background: #dddddd;
            border-radius: 50%;
          }
        }
      }
    }
    .hotcitylaw {
      width: 100%;
      height: 260px;
      background: #ffffff;
      margin-top: 30px;
      padding: 24px 20px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      .citylawlist {
        margin-top: 20px;
        .citylawitem {
          position: relative;
          margin-right: 60px;
          margin-bottom: 12px;
          padding-left: 8px;
          padding-bottom: 10px;
          &:hover {
            cursor: pointer;
            color: #0465ea;
            padding-bottom: 9px;
            border-bottom: 1px solid #0465ea;
          }
          &::before {
            content: "";
            position: absolute;
            top: 10px;
            left: 0;
            width: 4px;
            height: 4px;
            background-color: #aaa;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .zixun {
    width: 315px;
    .mb20 {
      margin-bottom: 20px;
    }
    .mt30 {
      margin-top: 30px;
    }
    .subtitle {
      font-size: 18px;
      line-height: 18px;
    }
    .crdelac {
      width: 100%;
      background: #ffffff;
      padding: 24px 16px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      ::v-deep .home-timeline-item__content {
        font-size: 14px;
        padding: 18px 10px;
      }
      ::v-deep .home-timeline-item {
        &:last-child .home-timeline-item__tail {
          height: 90%;
        }
      }
    }
    .crhotpro {
      width: 100%;
      height: 356px;
      padding: 24px 16px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(1, 1, 1, 0.1);
      ul {
        li {
          line-height: 34px;
          &:hover {
            color: #0465ea;
            cursor: pointer;
          }
        }
      }
    }
    .hotcharf {
      width: 100%;
      height: 500px;
      padding: 24px 16px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(1, 1, 1, 0.1);
      .item {
        margin-top: 22px;
        &:hover {
          .im2 {
            color: #0465ea;
          }
        }
        .im1 {
          width: 20px;
          text-align: center;
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            position: relative;
            top: -2px;
          }
          div {
            width: 20px;
            height: 20px;
            margin: 0 auto;
            line-height: 20px;
            font-size: 14px;
            border-radius: 50%;
            border: 1px solid #bcbcbc;
          }
        }
        .im2 {
          cursor: pointer;
          margin-left: 15px;
          width: 160px;
          font-size: 15px;
          color: #333333;
        }
        .im3 {
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}

.inlineclass{
	width: 314px;
	height: 318px;
	background-color: #ffffff;
	align-items: center;
	padding: 30px 35px;
	margin-top: 30px;
	box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
	.tit{
		margin-bottom: 50px;
	}
	.btn{
		width: 140px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		background: #F25717;
		border-radius: 18px;
		margin-top: 115px;
	}
}

      .laonswi {
        width: 840px;
        height: 320px;
        background-color: #e7e7e7;
        ::v-deep .is-active {
          .el-carousel__button {
            background-color: #1f7dff;
          }
        }
        .swiimg {
          img {
            width: 840px;
            height: 320px;
          }
        }
      }
      .laonsel {
		  width: 314px;
		  height: 195px;
		  background: #FFFFFF;
		  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        padding: 28px 20px;
		margin-top: 30px;
        .sele1 {
          width: 134px;
          height: 40px;
        }
        .sele2 {
          width: 100%;
          height: 40px;
        }
		.line{
			width: 10px;
			height: 2px;
			background: #D7D7D7;
			margin: 0 5px;
		}
        .kscz {
          cursor: pointer;
          margin-top: 20px;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          background: #0465ea;
          border-radius: 5px;
        }
      }
</style>